<div
  class="{{ extraClass }} w-full flex items-center text-txt font-semibold text-sm leading-sm"
  [ngClass]="{
    'justify-end text-right': rightAlign,
    'justify-center text-center': centerAlign,
    'cursor-pointer': sortable,
    '!text-primary': isHeaderActive()
  }"
  (click)="simpleSort ? emitSimpleSort() : menuTrigger.openMenu()"
>
  <div #labelSlot>
    <ng-content select="[slot=label]"></ng-content>
  </div>
  @if (!labelSlot.children.length) {
    <span>{{ label }}</span>
  }
  @if (infoTitle) {
    <div
      [llaTippy]="infoTooltipTemplate"
      [llaTippyProps]="tooltipOption"
      class="hidden md:flex ml-[6px] text-primary {{ infoTitleClass }}"
    >
      <svg-icon key="info-circle" class="text-xs!"></svg-icon>
    </div>
  }
  @if (isHeaderActive()) {
    <span class="pl-[6px]">
      <svg-icon
        key="arrow-up-full"
        fontSize="9px"
        [ngClass]="{ 'rotate-180': sortState?.direction === 'desc' }"
      ></svg-icon>
    </span>
  }
</div>
<div [matMenuTriggerFor]="sortable ? sortMenu : null" #menuTrigger="matMenuTrigger"></div>

<!-- Filter Menu -->
<mat-menu
  #sortMenu="matMenu"
  class="table-header-sort-menu"
  [xPosition]="rightAlign ? 'before' : 'after'"
  [hasBackdrop]="true"
  backdropClass="lla-transparent-menu-backdrop"
>
  <ng-template matMenuContent>
    <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      @if (label) {
        <div class="sort-menu-header">{{ label }}</div>
      }
      <div class="sort-menu-body">
        @for (info of sortInfo; track info; let isLast = $last) {
          <div
            class="sort-menu-row"
            [ngClass]="{ 'sort-menu-row-labeled': info.title || info.subtitle }"
          >
            @if (info.title || info.subtitle) {
              <div class="sort-menu-label">
                @if (info.title) {
                  <div class="sort-menu-title">{{ info.title }}</div>
                }
                @if (info.subtitle) {
                  <div class="sort-menu-subtitle">{{ info.subtitle }}</div>
                }
              </div>
            }
            <div class="sort-menu-actions">
              <div
                class="sort-btn"
                [ngClass]="{
                  'sort-btn-active':
                    sortState && sortState.active === info.columnName && sortState.direction === 'desc'
                }"
                (click)="
                  sortChanged.emit(
                    sortStateService.update({ active: info.columnName, direction: 'desc' }, sortState)
                  );
                  menuTrigger.closeMenu()
                "
              >
                <span>{{ info.isNumber ? 'High' : 'Descending' }}</span>
                <div class="sort-btn-icon">
                  <svg-icon key="arrow-down-full" class="text-2xs!"></svg-icon>
                </div>
              </div>
              <div
                class="sort-btn"
                [ngClass]="{
                  'sort-btn-active':
                    sortState && sortState.active === info.columnName && sortState.direction === 'asc'
                }"
                (click)="
                  sortChanged.emit(
                    sortStateService.update({ active: info.columnName, direction: 'asc' }, sortState)
                  );
                  menuTrigger.closeMenu()
                "
              >
                <span>{{ info.isNumber ? 'Low' : 'Ascending' }}</span>
                <div class="sort-btn-icon">
                  <svg-icon key="arrow-up-full" class="text-2xs!"></svg-icon>
                </div>
              </div>
            </div>
          </div>
          @if (!isLast) {
            <div class="sort-menu-divider"></div>
          }
        }
      </div>
    </div>
  </ng-template>
</mat-menu>

<ng-template #infoTooltipTemplate>
  <div class="max-w-[300px] relative">
    <div class="text-sm leading-sm text-txt font-semibold pb-xs bg-contrast sticky top-0">
      <span #infoTitleSlot>
        <ng-content select="[slot=infoTitle]"></ng-content>
      </span>
      @if (!infoTitleSlot.children.length) {
        <span>{{ infoTitle }}</span>
      }
    </div>
    @if (infoSubtitle) {
      <div class="text-sm leading-sm text-txt">
        {{ infoSubtitle }}
      </div>
    }
    @if (infoList && infoList.length > 0) {
      <div class="flex flex-wrap items-center gap-xs">
        @for (item of infoList; track i; let i = $index; let isLast = $last) {
          <div class="capitalize text-sm leading-sm text-txt">{{ item }}{{ !isLast ? ',' : '' }}</div>
        }
      </div>
    }
  </div>
</ng-template>
